.lab {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-2) 0;
}

.controls {
  display: inline-flex;
  gap: var(--tuna-spacing-2);
  flex-wrap: wrap;
  align-items: center;
}
